module.exports = {"pathContext":{"name":"AgedArReportGeneration","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"status","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"AgedArReportStatus","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"topic","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-aged-ar-report-generation.json
// module id = 1642
// module chunks = 99120839622897